import {Component} from 'vue-property-decorator';
import Vue from 'vue';
import {Action, State} from 'vuex-class';
import {
  ServiceTransactionInitState, VerifyCodeInterface
} from '@/store/service-transaction/service-transaction.types';
import {MemberInitState, MemberTimeInformation, TimeInformation} from '@/store/member/member.types';
import {FormValidate} from '@/services/form-validate';
import {Toast} from '@/store/toast/toast.types';

@Component({
  components: {}
})
export default class CodeVerifyComponent extends Vue {
  @State('serviceTransaction') serviceTransactionInitState!: ServiceTransactionInitState;
  @State('member') memberInitState!: MemberInitState;
  @Action('_verifyCode', {namespace: 'serviceTransaction'}) verifyCode!: (body: VerifyCodeInterface) => Promise<void>;
  @Action('_Toast', {namespace: 'toast'}) Toast!: (payload: Toast) => Promise<void>;
  @Action('_Loading', {namespace: 'loading'}) Loading!: (payload: boolean) => Promise<void>;


  public code = '';


  async mounted() {
  }

  async verifyCodeClick() {
    try {
      this.Loading(true);
      let forms = document.getElementsByClassName('verify-code');
      let valid = FormValidate.validate(forms);
      if (!valid) {
        this.Toast({
          heading: '!',
          message: 'กรุณากรอกข้อมูลตามที่กำหนด',
          type: 'danger'
        }).then();
        return;
      }
      await this.verifyCode({startCode: this.code});
      this.Loading(false);
      this.$router.push('/payment-information').then();

    } catch (e) {
      this.Loading(false);
      console.error('DEBUG: verifyCodeClick', e.message);
    }
  }

}


